/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne Swagger
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 4bcfc99b (Thu Mar  7 14:01:07 UTC 2024)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  CashAmount,
  CashAmountFromJSON,
  CashAmountToJSON,
  StudentToProgramType,
  StudentToProgramTypeFromJSON,
  StudentToProgramTypeToJSON,
} from './'

/**
 * Object that encapsulates the information needed for each invoice.
 * @export
 * @interface InvoiceInfo
 */
export interface InvoiceInfo {
  /**
   * The unique identifier of the invoice sent by the director or tutor.
   * @type {number}
   * @memberof InvoiceInfo
   */
  invoiceKey: number
  /**
   * The date the invoice was sent.
   * @type {Date}
   * @memberof InvoiceInfo
   */
  dateSent: Date
  /**
   *
   * @type {CashAmount}
   * @memberof InvoiceInfo
   */
  amountOwed: CashAmount
  /**
   * List of studentName-programType pair objects associated to the sent invoice.
   * @type {Array<StudentToProgramType>}
   * @memberof InvoiceInfo
   */
  studentPrograms: Array<StudentToProgramType>
}

export function InvoiceInfoFromJSON(json: any): InvoiceInfo {
  return InvoiceInfoFromJSONTyped(json, false)
}

export function InvoiceInfoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): InvoiceInfo {
  if (json === undefined || json === null) {
    return json
  }
  return {
    invoiceKey: json['invoiceKey'],
    dateSent: new Date(json['dateSent']),
    amountOwed: CashAmountFromJSON(json['amountOwed']),
    studentPrograms: (json['studentPrograms'] as Array<any>).map(
      StudentToProgramTypeFromJSON
    ),
  }
}

export function InvoiceInfoToJSON(value?: InvoiceInfo | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    invoiceKey: value.invoiceKey,
    dateSent: value.dateSent.toISOString(),
    amountOwed: CashAmountToJSON(value.amountOwed),
    studentPrograms: (value.studentPrograms as Array<any>).map(
      StudentToProgramTypeToJSON
    ),
  }
}
